import React from 'react'
import Header from '../../../home/Header'
import Footer from '../../Footer'
import HowToUse from './HowToUse'

export default function index() {
  return (
    <div>
        <Header/>
        <HowToUse/>
        <Footer/>
    </div>
  )
}
